"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSSESSIVE = exports.ALONE = exports.REFLEXIVE = exports.THIRD_PERSON = exports.SECOND_PERSON = exports.FIRST_PERSON = void 0;
exports.FIRST_PERSON = [
    'ja',
    'mene',
    'me',
    'mne',
    'mi',
    'mnoju',
    'my',
    'nas',
    'nam',
    'nami',
];
exports.SECOND_PERSON = [
    'ty',
    'tebe',
    'te',
    'tobe',
    'ti',
    'toboju',
    'vy',
    'vas',
    'vam',
    'vami',
];
exports.THIRD_PERSON = [
    'on',
    'jego',
    'go',
    'je',
    'jemu',
    'mu',
    'njim',
    'ona',
    'ono',
    'ju',
    'jej',
    'jeju',
    'njeju',
    'oni',
    'one',
    'jih',
    'jim',
    'njimi',
];
exports.REFLEXIVE = ['sebe', 'se', 'sobe', 'si', 'soboju'];
exports.ALONE = ['sam', 'sama', 'samo', 'sami', 'same'];
exports.POSSESSIVE = ['jih', 'jej', 'jego'];
//# sourceMappingURL=lookups.js.map